import { render, staticRenderFns } from "./DichVuDiemDenForm.vue?vue&type=template&id=679b3dbc&scoped=true"
import script from "./DichVuDiemDenForm.vue?vue&type=script&lang=js"
export * from "./DichVuDiemDenForm.vue?vue&type=script&lang=js"
import style0 from "./DichVuDiemDenForm.vue?vue&type=style&index=0&id=679b3dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679b3dbc",
  null
  
)

export default component.exports